import React, { useState, useEffect, useContext } from "react";
import FlightIcon from '@mui/icons-material/Flight';
import DirectionsBoatFilledOutlinedIcon from '@mui/icons-material/DirectionsBoatFilledOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

export interface IAnalyticsWidgetModel {
    widgetId: number,
    parentId: number | null,
    label: string,
    bookingType: string,
    icon: JSX.Element,
    isDisplay: boolean,
    xPosition: number | null,
    yPosition: number | null,
    value: number,
    backgroundColor: string,
    backgroundColorOpacity: string
}

export enum Widget {
    AllQuotes,
    SeaQuotes,
    AirQuotes,
    FCLBookings,
    AllBookings,
    SeaBookings,
    AirBookings,
    LCLBookings
}

export const analyticsWidgetModel: IAnalyticsWidgetModel [] =
    [
        {
            widgetId: 0,
            parentId: null,
            label: 'All',
            bookingType: 'Quotes',
            icon: <FactCheckOutlinedIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#2059A7',
            backgroundColorOpacity: 'rgba(32, 89, 167, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 1,
            parentId: 0,
            label: 'Sea',
            bookingType: 'Quotes',
            icon: <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#2059A7',
            backgroundColorOpacity: 'rgba(32, 89, 167, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 2,
            parentId: 0,
            label: 'Air',
            bookingType: 'Quotes',
            icon: <FlightIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#2059A7',
            backgroundColorOpacity: 'rgba(32, 89, 167, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 3,
            parentId: 4,
            label: 'FCL',
            bookingType: 'Bookings',
            icon: <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#1DB35A',
            backgroundColorOpacity: 'rgba(45, 179, 74, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 4,
            parentId: null,
            label: 'All',
            bookingType: 'Bookings',
            icon: <AutoStoriesIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#1DB35A',
            backgroundColorOpacity: 'rgba(45, 179, 74, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 5,
            parentId: 4,
            label: 'Sea',
            bookingType: 'Bookings',
            icon: <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#1DB35A',
            backgroundColorOpacity: 'rgba(45, 179, 74, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 6,
            parentId: 4,
            label: 'Air',
            bookingType: 'Bookings',
            icon: <FlightIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#1DB35A',
            backgroundColorOpacity: 'rgba(45, 179, 74, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        },
        {
            widgetId: 7,
            parentId: 4,
            label: 'LCL',
            bookingType: 'Bookings',
            icon: <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 'xxx-large' }} />,
            backgroundColor: '#1DB35A',
            backgroundColorOpacity: 'rgba(45, 179, 74, 0.5)',
            isDisplay: true,
            xPosition: null,
            yPosition: null,
            value: 0
        }
    ];

export const analyticsDisplayModelVisibilityKey = 'DASHBOARD_WIDGET_VISIBILITY';

export interface IAnalyticsDisplayModel {
    widgetId: number,
    parentId: number | null,
    isDisplay: boolean,
    xPosition: number | null,
    yPosition: number | null
}

export const analyticsDisplayModel: IAnalyticsDisplayModel [] =
    [
        {
            widgetId: 0,
            parentId: null,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 1,
            parentId: 0,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 2,
            parentId: 0,
            isDisplay: true,
            xPosition: null,
            yPosition: null

        },
        {
            widgetId: 3,
            parentId: null,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 4,
            parentId: null,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 5,
            parentId: 4,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 6,
            parentId: 4,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        },
        {
            widgetId: 7,
            parentId: null,
            isDisplay: true,
            xPosition: null,
            yPosition: null
        }
    ];
